import AppDataService from "./AppDataService";

const COMMON_BASE = 'SignUp'

export default class SignUpDataService {
    static async validateEmailExists(email){
        return await AppDataService.post(`${COMMON_BASE}/CheckExist`, email, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }
    static async signUp(signUnData){
        return await AppDataService.post(COMMON_BASE, signUnData, {
            headers: {
                'Content-Type': 'application/json'
            },
        });
    }

    static async submitAcceptInvitationRequest(acceptInvitationData){
        return await AppDataService.post(`${COMMON_BASE}/AcceptInvitation`, acceptInvitationData);
    }
}